module.exports = __webpack_public_path__ + "static/media/mk.85f7e863.svg";